<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>
      <div class="center">爱心捐赠</div>
      <div class="right" @click="toHome()">
        <van-icon name="wap-home" size="21"/>
      </div>
    </div>
    <div class="padding content">
      <van-field v-model="username" required label="姓名" clearable placeholder="请输入姓名" />
      <van-field v-model="telphone" required label="联系方式" clearable type="tel" placeholder="请输入联系方式" />
      <van-field v-model="num" required label="捐赠数量" clearable type="digit" placeholder="请输入捐赠数量" />
      <van-field
        readonly
        clickable
        name="picker"
        :value="value"
        required
        label="物资"
        placeholder="点击选择物资"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          title="只接受全新物资"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <div class="comfirm-btn" @click="toSubmit()">提交</div>
    </div>
    <van-dialog v-model="show" title="提示" show-cancel-button :beforeClose="beforeClose">
      <div style="margin:1.5rem 0">确定要提交吗？</div>
    </van-dialog>
  </div>
</template>
<script>
import {
  Icon,
  Field,
  RadioGroup,
  Radio,
  Toast,
  Dialog,
  Picker,
  Popup,
} from "vant";
import { helpDonate } from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      info: [],
      type: "",
      username: "",
      telphone: "",
      num: "",
      radio: "1",
      show: false,
      value: "",
      columns: [
        "衣服",
        "书籍",
        "旅行用具",
        "粮油食品",
        "电脑",
        "餐具",
        "小推车",
        "雨具",
        "鞋子",
        "文具用品",
        "书桌椅",
        "棉被",
        "辅助器具",
        "其它",
      ],
      showPicker: false,
    };
  },
  filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {},
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome() {
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
      // this.$router.push("/index");
    },
    toSubmit() {
      if (this.username == "") {
        Toast("请输入姓名");
      } else if (!/^1[34578]\d{9}$/.test(this.telphone)) {
        Toast("请输入正确的电话号码");
      } else if (this.num == "") {
        Toast("请输入捐赠数量");
      }else if (this.value == "") {
        Toast("请选择捐赠物资");
      }  else {
        this.show = true;
      }
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        var parm = {
          username: this.username,
          telphone: this.telphone,
          num: this.num,
          item: this.value,
        };
        helpDonate(parm).then((res) => {
          Toast(res.message);
          if (res.status == 1) {
            this.$router.push({
              path: "/successful",
              query: {
                type: 1,
              },
            });
          }
        });
      } else {
        done();
      }
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
  },
};
</script>
<style scoped>
.info-tit {
  font-weight: bold;
}
.content {
  width: 90%;
  margin: 0 auto;
  /* padding-top: 1rem; */
  /* margin-top: 10%; */
  text-align: left;
}
.info-tit {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 1rem 0;
}
.info-time {
  font-size: 0.9rem;
  color: gray;
}
.info-time span {
  color: #72b550;
  margin-right: 1rem;
}
.infos {
  font-size: 1rem;
  text-indent: 2rem;
}
.info-img {
  text-align: center;
  margin: 1rem 0;
}
.info-img img {
  width: 80%;
  margin: 0 auto;
}
.list {
  border-bottom: solid 1px gainsboro;
  color: gray;
  padding: 1rem 0;
}
.comfirm-btn {
  width: 95%;
  margin: 0 auto;
  background: #6dcc13;
  height: 2.5rem;
  line-height: 2.5rem;
  color: white;
  text-align: center;
  margin-top: 2rem;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/page/helpDonate.vue